import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Autocomplete from 'react-autocomplete'

import '../css/FICAutocomplete.css'
import FICTooltip from '../../components/js/FICTooltip'

class FICAutocomplete extends Component {
  constructor (props) {
    super(props)
    this.autocompleteRef = null
    this.firstLoad = false
    this.filter = props.value
    this.scheduledChange = null
    this.scheduledLoadOptions = null
    this.lastOnChangeValue = props.value || undefined
    this.state = {
      useInternalValue: false,
      internalValue: props.value || undefined
    }
  }

  componentDidMount () {
    if (this.props.autoFocus) {
      setTimeout(() => {
        this.focus()
        setTimeout(() => {
          this.setState({ useInternalValue: false })
        }, 0)
      }, 100)
    }
  }

  focus = () => {
    if (this.autocompleteRef) {
      this.autocompleteRef.focus()
    }
  }

  blur = () => {
    if (this.autocompleteRef) {
      this.autocompleteRef.blur()
    }
  }

  shouldUseInternalValue = () => {
    return this.props.changeOnBlur || (!this.props.uncontrolled && this.props.changeDelay)
  }

  getDisplayValue = () => {
    const props = this.props
    const state = this.state
    return this.shouldUseInternalValue() && state.useInternalValue ? (state.internalValue || '')
      : props.value != null ? props.value
        : ''
  }

  handleChange = (e) => {
    const props = this.props
    const value = e.target.value
    // Options
    this.filter = value
    if (props.loadOptions) {
      this.cancelScheduledLoadOptions()
      if (props.triggerLength <= value.length) {
        this.scheduleLoadOptions(value)
      }
    }
    // General input
    if (props.clearable) {
      this.setState({ clearableVisible: value })
    }
    if (this.shouldUseInternalValue()) {
      this.setState({ internalValue: value })
    }
    if (props.changeDelay) {
      this.cancelScheduledChange()
      this.scheduleChange(value)
    } else {
      this.executeOnChange(value)
    }
  }

  executeOnChange = (value) => {
    const props = this.props
    if (props.onChange && value !== this.lastOnChangeValue) {
      this.lastOnChangeValue = value
      props.onChange(props.name, value, null, 'autocomplete')
    }
  }

  handleSelect = (value, data) => {
    const props = this.props
    value = data[props.valueKey ? props.valueKey : props.labelKey]
    this.cancelScheduledChange()
    this.cancelScheduledLoadOptions()
    if (this.shouldUseInternalValue()) {
      this.setState({ internalValue: value })
    }
    if (!props.preventChangeOnSelect) {
      this.executeOnChange(value)
    }
    if (props.onSelect) {
      this.lastOnChangeValue = value
      props.onSelect(value, data)
    }
  }

  handleFocus = (e) => {
    const props = this.props
    if (this.shouldUseInternalValue()) {
      this.setState({
        useInternalValue: true,
        internalValue: props.value
      })
    }
    if (props.onFocus) {
      props.onFocus(e)
    }
  }

  handleBlur = (e) => {
    const props = this.props
    const value = e.target.value
    this.setState({ useInternalValue: false })
    if (props.changeOnBlur) {
      this.executeOnChange(value)
    }
    if (props.onBlur) {
      props.onBlur(e)
    }
  }

  scheduleChange = (value) => {
    this.scheduledChange = setTimeout(() => {
      this.executeOnChange(value)
    }, this.props.changeDelay)
  }

  cancelScheduledChange = () => {
    if (this.scheduledChange) {
      clearTimeout(this.scheduledChange)
    }
  }

  scheduleLoadOptions = (value) => {
    this.scheduledLoadOptions = setTimeout(() => this.props.loadOptions(value), this.props.loadOptionsDelay)
  }

  cancelScheduledLoadOptions = () => {
    if (this.scheduledLoadOptions) {
      clearTimeout(this.scheduledLoadOptions)
    }
  }

  render () {
    let { placeholder, options, loadOptions, value, idKey, valueKey, labelKey, triggerLength, maxMenuHeight, renderMenuContent, renderItem, validator, shouldItemRender, ...props } = this.props
    let className = 'fic-autocomplete'
    if (maxMenuHeight) {
      className += ' fic-height-' + maxMenuHeight
    }
    if (props.className) {
      className += ' ' + props.className
    }
    let inputClassName = 'fic-input-text-input'
    if (validator && !validator.valid) {
      inputClassName += ' fic-input-invalid'
    }
    if (props.disabled) {
      inputClassName += ' fic-input-disabled'
    }
    value = this.getDisplayValue()
    const result = <Autocomplete
      ref={(ref) => {
        this.autocompleteRef = ref
      }}
      wrapperProps={{ className: className }}
      getItemValue={(item) => item[valueKey || labelKey]}
      wrapperStyle={{
        position: 'relative'
      }}
      renderMenu={(items, value, style) => {
        if (renderMenuContent) {
          return renderMenuContent(items, value, style)
        }

        if (!items || items.length === 0) {
          return <div />
        }
        style.minWidth = 0
        if (maxMenuHeight) {
          style.maxHeight = 30 * maxMenuHeight
        }
        const displayMenu = triggerLength > this.filter.length ? 'none' : 'block'
        return <div className='fic-autocomplete-menu-outer' style={{ display: displayMenu }}>
          <div style={style} children={items} className='fic-autocomplete-menu' />
        </div>
      }}
      menuStyle={{
        position: 'absolute',
        top: 30,
        left: 0
      }}
      items={options}
      renderItem={(item, isHighlighted, styles) => {
        let className = 'fic-autocomplete-option'
        if (isHighlighted) {
          className += ' is-focused'
        }
        return renderItem
          ? renderItem(item, className, styles)
          : <div key={item[idKey || labelKey]} className={className}>{item[labelKey]}</div>
        /* <div style={{ background: isHighlighted ? 'lightgray' : 'white' }}>
          {item.label}
        </div> */
      }}
      // renderInput={(props) => <FICInputText {...props}/>}
      shouldItemRender={(item, value) => {
        return shouldItemRender ? shouldItemRender(item, value)
          : item[labelKey] && item[labelKey].toLowerCase().indexOf(value.toLowerCase()) > -1
      }}

      inputProps={{
        className: inputClassName,
        placeholder: placeholder,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onKeyPress: props.onKeyPress,
        onKeyDown: props.onKeyDown,
        onKeyUp: props.onKeyUp,
        onClick: props.onClick,
        onMouseOver: props.onMouseOver,
        onMouseOut: props.onMouseOut,
        autoComplete: 'new-password',
        disabled: props.disabled,
        maxLength: props.maxLength
      }}
      value={value}
      onChange={this.handleChange}
      /* onChange={(event) => {
        const value = event.target.value
        this.filter = value
        if (onChange) {
          onChange(name, value, null, 'autocomplete')
          if (loadOptions) {
            if (this.scheduledChange)
              clearTimeout(this.scheduledChange)
            if (triggerLength <= this.filter.length)
              this.scheduledChange = setTimeout(() => loadOptions(value), loadOptionsDelay)
          }
        }
      }} */
      onSelect={this.handleSelect}
      onMenuVisibilityChange={(isOpen) => {
        if (isOpen && !this.firstLoad && loadOptions && triggerLength <= this.filter.length) {
          this.firstLoad = true
          loadOptions('')
        }
      }}
      /*
      placeholder={this.props.placeholder}
      clearable={this.props.clearable ? this.props.clearable : false}
      backspaceRemoves={false}
      deleteRemoves={false}
      autosize={false}
      value={this.props.value}
      valueKey={this.valueKey}
      labelKey={this.labelKey}
      autoload={false}
      onChange={(val) => this.props.onChange(this.props.name, val ? val[this.valueKey] : null, val ? val[this.labelKey] : null, 'typeahead')}
      noResultsText="Nessuna corrispondenza trovata"
      promptTextCreator={(label) => { return 'Crea nuovo "' + label + '"'}}
      searchPromptText="Inizia a digitare"
      loadingPlaceholder="Caricamento..."
      {...options}
      */
    />
    return this.props.validator
      ? <FICTooltip
        placement='top'
        text={this.props.validator.message}
        trigger={this.props.validator.valid ? [] : [ 'hover', 'focus' ]}
        enabled={!this.props.validator.valid}>
        <div>{result}</div>
      </FICTooltip> : result
  }
}

FICAutocomplete.propTypes = {
  className: PropTypes.string,
  options: PropTypes.array,
  loadOptions: PropTypes.func,
  loadOptionsDelay: PropTypes.number,
  triggerLength: PropTypes.number,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  idKey: PropTypes.string,
  valueKey: PropTypes.string,
  labelKey: PropTypes.string,
  emptyLabel: PropTypes.string,
  placeholder: PropTypes.string,
  onSelect: PropTypes.func,
  onChange: PropTypes.func,
  changeOnBlur: PropTypes.bool,
  changeDelay: PropTypes.number,
  clearable: PropTypes.bool,
  disabled: PropTypes.bool,
  maxMenuHeight: PropTypes.number,
  preventChangeOnSelect: PropTypes.bool,
  renderMenuContent: PropTypes.func,
  renderItem: PropTypes.func,
  autoFocus: PropTypes.bool,
  maxLength: PropTypes.number
}

FICAutocomplete.defaultProps = {
  className: undefined,
  options: [],
  loadOptions: undefined,
  loadOptionsDelay: 0,
  triggerLength: 0,
  value: '',
  idKey: undefined,
  valueKey: undefined,
  labelKey: 'label',
  emptyLabel: '',
  placeholder: '',
  onSelect: undefined,
  onChange: undefined,
  changeOnBlur: true,
  changeDelay: 500,
  clearable: true,
  disabled: undefined,
  maxMenuHeight: undefined,
  preventChangeOnSelect: false,
  renderMenuContent: undefined,
  renderItem: undefined,
  autoFocus: false,
  maxLength: undefined
}

export default FICAutocomplete

function AutocompleteTooltipAdapter (props) {
  let newProps = Object.assign({}, props)
  if (newProps['aria-describedby']) {
    newProps.inputProps['aria-describedby'] = newProps['aria-describedby']
  }
  return <Autocomplete {...newProps} />
}



// WEBPACK FOOTER //
// ./src/common/forms/js/FICAutocomplete.js